/* eslint-disable no-unused-vars */
// FilePondUpload.js
import React from 'react';
import PropTypes from 'prop-types';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import uuid from 'react-uuid';
// Import FilePond plugins
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

// Register the plugins
registerPlugin(
  FilePondPluginFileEncode,
  FilePondPluginFileMetadata,
  FilePondPluginFileValidateSize,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview
);

const FilePondUpload = ({ onChange }) => {
  const [unique_id] = React.useState(uuid());
  const sessionGet = (key) => localStorage.getItem(key);

  const token = sessionGet('token');

  return (
    <FilePond
      server={{
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          const formData = new FormData();
          formData.append('file', file, file.name);
          formData.append('tag', unique_id);

          const request = new XMLHttpRequest();
          request.open(
            'POST',
            `${process.env.REACT_APP_WS}/api/v1/administrators/civil_registries/temp_upload`
          );

          request.setRequestHeader('Authorization', `Bearer ${token}`);

          request.upload.onprogress = (e) => {
            progress(e.lengthComputable, e.loaded, e.total);
          };

          /* eslint-disable */
          request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
              load(request.responseText);
              if (onChange) {
                onChange(unique_id);
              }
            } else {
              error('oh no');
            }
          };

          request.onerror = function () {
            error('oh no');
          };

          console.log('formData', formData);

          request.send(formData);

          return {
            abort: () => {
              request.abort();
              abort();
            },
          };
        },
        revert: (uniqueFileId, load, error) => {
          const payload = {
            file_name: uniqueFileId.filename,
            tag: unique_id,
          };

          fetch(
            `${process.env.REACT_APP_WS}/api/v1/administrators/civil_registries/revert_temp_upload`,
            {
              method: 'POST',
              headers: {
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(payload),
            }
          )
            .then(() => {
              load();
            })
            .catch(() => {
              error('oh no');
            });
        },
      }}
      name="filepond"
      allowMultiple
      maxFiles={3}
      maxFileSize="30MB"
      maxTotalFileSize="30MB"
      labelMaxFileSizeExceeded="Maximum file size is 30mb"
      labelMaxFileSize="Maximum file size is 30mb"
      labelMaxTotalFileSizeExceeded="Maximum file size is 30mb"
      labelMaxTotalFileSize="Maximum file size is 30mb"
    />
  );
};

FilePondUpload.propTypes = {
  onChange: PropTypes.instanceOf(Function).isRequired,
};

export default FilePondUpload;
